import type { ReactNode } from "react";
import { Link } from "react-router";
import { Container } from "@/components/ds";
import { Heading, Text } from "@/components/ds";
import styles from "./LegalPageShell.module.css";

interface LegalPageShellProps {
  readonly title: string;
  readonly lastUpdated: string;
  readonly summary: ReactNode;
  readonly children: ReactNode;
}

export function LegalPageShell({
  title,
  lastUpdated,
  summary,
  children,
}: LegalPageShellProps) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Container>
          <div className={styles.headerInner}>
            <Link to="/" className={styles.logo} aria-label="TidyRota home">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                aria-hidden="true"
              >
                <rect
                  width="28"
                  height="28"
                  rx="6"
                  fill="var(--color-accent-solid)"
                />
                <path
                  d="M8 14.5L12 18.5L20 10.5"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className={styles.wordmark}>TidyRota</span>
            </Link>
          </div>
        </Container>
      </header>

      <main className={styles.main}>
        <Heading level={1} size="h3">
          {title}
        </Heading>
        <Text size="sm" color="muted" className={styles.lastUpdated}>
          Last updated: {lastUpdated}
        </Text>

        <div className={styles.summary}>
          <span className={styles.summaryLabel}>In short</span>
          <Text size="base">{summary}</Text>
        </div>

        <div className={styles.body}>{children}</div>
      </main>

      <footer className={styles.footer}>
        <Container>
          <div className={styles.footerInner}>
            <Text size="sm" color="muted">
              TidyRota is a trading name of Jack Hodkinson.
            </Text>
            <div className={styles.footerLinks}>
              <Link to="/privacy" className={styles.footerLink}>
                Privacy
              </Link>
              <Link to="/terms" className={styles.footerLink}>
                Terms
              </Link>
              <a
                href="mailto:hello@tidyrota.com"
                className={styles.footerLink}
              >
                Contact
              </a>
            </div>
          </div>
        </Container>
      </footer>
    </div>
  );
}
